import { render, staticRenderFns } from "./DesignerMenu.vue?vue&type=template&id=5c301d8b&scoped=true"
import script from "./DesignerMenu.vue?vue&type=script&lang=js"
export * from "./DesignerMenu.vue?vue&type=script&lang=js"
import style0 from "./DesignerMenu.vue?vue&type=style&index=0&id=5c301d8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c301d8b",
  null
  
)

export default component.exports